import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-download",
  "use": "icon-cl-download-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-download\"><path d=\"M7.4 2a.6.6 0 0 0-.598.6v4.8H4.705a.3.3 0 0 0-.193.53l3.059 2.888.02.02a.6.6 0 0 0 .819 0l.008-.008a.293.293 0 0 0 .006-.007l3.057-2.887a.311.311 0 0 0 .018-.017l.005-.003c0-.002.002-.003.003-.004a.3.3 0 0 0-.212-.512H9.198V2.6A.6.6 0 0 0 8.6 2H7.4ZM2.609 12.8a.598.598 0 0 0-.562.832.6.6 0 0 0 .562.368h10.784a.596.596 0 0 0 .562-.368.601.601 0 0 0-.562-.832H2.608Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol